import { memo } from 'react';
import { useSelector } from 'react-redux';
import {
  itemBottomGapStyle,
  itemTitleStyle,
  isHiddenInPrint,
  isExistAnyBreastData,
  isExistAnyOthersData,
  isExistAnyCardiologyData,
  isExistAnyDentalData,
  isExistAnyEarNoseThrothsData,
  isExistAnyGyneData,
  isExistAnyOncologyData,
  isExistAnyOnExamination,
  isExistGeneralExaminationData,
  isExistObservationData,
  isExistAnyNervousSystemData,
  isExistAnyUrologyExaminationData,
  isExistAnyMentalStateExaminationData,
} from '../../../../utils/helpers';
import DentalView from '../views/dental';
import GeneralExaminationView from '../views/generalExaminationView';
import GyneExaminationView from '../views/gyne';
import ObservationView from '../views/observation';
import EyeExaminationView from '../views/eyeExaminationView';
import OcularExaminationView from '../views/ocularExaminationView';
import OncologyExaminationView from '../views/oncologyExamination';
import SystemicExaminationView from '../views/systemicExamination';
import EarNoseThrothExamination from './earNoseThroatExamination';
import NervousSystem from './nervousSystem';
import UrologyExaminationView from './urologyExaminationView';
import MentalStateExaminationView from './mentalStateExaminationView';
import GeneralExaminationViewNurology from './generalExaminationViewNurology';

const OnExamination = ({
  element,
  prescriptionItems,
  selectedOnExamination,
  setShowOnExamination,
  deletePrescriptionItem,
  setSelectedOnExamination,
  isHistoryPage = false,
  isInRightSide = false,
}) => {
  const userInfo = useSelector((state) => state.authReducer.data);

  const prescriptionItemCSSObject = () => itemBottomGapStyle(element, !isExistAnyOnExamination(selectedOnExamination));

  return (
    <div
      className={`row item-row ${
        !isExistAnyOnExamination(selectedOnExamination) ? '' : 'pb-2'
      }`}
      key={`onExamination`}
      style={prescriptionItemCSSObject()}
    >
      <div
        className={`prescription-item ${
          isHiddenInPrint(prescriptionItems, 'on-examination')
            ? 'item-title-hide'
            : ''
        }`}
        style={itemTitleStyle(
          prescriptionItems?.items?.['on-examination']?.titleStyle || {},
        )}
        {...(!isHistoryPage
          ? {
              onClick: (e) => {
                e.stopPropagation();
                setShowOnExamination(true);
              },
            }
          : {})}
      >
        {element?.alterName?.length ? (
          <span>{element?.alterName}</span>
        ) : (
          <span>On Examinations</span>
        )}
      </div>
      <div
        className={`${
          isInRightSide
            ? 'on-examination-view-area item_right_width_99'
            : 'on-examination-view-area'
        }`}
      >
        {isExistObservationData(
          selectedOnExamination?.observations,
          'observation',
        ) && (
          <ObservationView
            selectedOnExamination={selectedOnExamination}
            setSelectedOnExamination={setSelectedOnExamination}
            deletePrescriptionItem={deletePrescriptionItem}
            prescriptionItems={prescriptionItems}
            isHistoryPage={isHistoryPage}
          />
        )}
        {isExistGeneralExaminationData(
          selectedOnExamination?.generalExaminations,
        ) &&
          userInfo?.speciality[0] !== '62eb9ede374ac6d73b089981' && (
            <GeneralExaminationView
              selectedOnExamination={selectedOnExamination}
              setSelectedOnExamination={setSelectedOnExamination}
              prescriptionItems={prescriptionItems}
              isHistoryPage={isHistoryPage}
            />
          )}

        {/* General examination view for all except nurology */}
        {isExistGeneralExaminationData(
          selectedOnExamination?.generalExaminations,
        ) &&
          userInfo?.speciality[0] === '62eb9ede374ac6d73b089981' && (
            <GeneralExaminationViewNurology
              selectedOnExamination={selectedOnExamination}
              setSelectedOnExamination={setSelectedOnExamination}
              prescriptionItems={prescriptionItems}
              isHistoryPage={isHistoryPage}
            />
          )}

        {/* General examination view for nurology */}
        {isExistAnyCardiologyData(selectedOnExamination?.systemicExamination) &&
          userInfo?.speciality[0] === '62eb9ede374ac6d73b089981' && (
            <SystemicExaminationView
              selectedOnExamination={selectedOnExamination}
              setSelectedOnExamination={setSelectedOnExamination}
              prescriptionItems={prescriptionItems}
              isHistoryPage={isHistoryPage}
            />
          )}

        <OcularExaminationView
          selectedOnExamination={selectedOnExamination}
          setSelectedOnExamination={setSelectedOnExamination}
          prescriptionItems={prescriptionItems}
          isHistoryPage={isHistoryPage}
        />

        <EyeExaminationView
          selectedOnExamination={selectedOnExamination}
          setSelectedOnExamination={setSelectedOnExamination}
          prescriptionItems={prescriptionItems}
          isHistoryPage={isHistoryPage}
        />

        {isExistAnyOncologyData(selectedOnExamination?.oncologyExamination) && (
          <OncologyExaminationView
            selectedOnExamination={selectedOnExamination}
            setSelectedOnExamination={setSelectedOnExamination}
            prescriptionItems={prescriptionItems}
            isHistoryPage={isHistoryPage}
          />
        )}

        {/* General Examination view for others */}
        {isExistAnyCardiologyData(
          selectedOnExamination?.systemicExamination,
        ) && (
          <SystemicExaminationView
            selectedOnExamination={selectedOnExamination}
            setSelectedOnExamination={setSelectedOnExamination}
            prescriptionItems={prescriptionItems}
            isHistoryPage={isHistoryPage}
          />
        )}
        {/* General examination view for nurology */}
        {/* {isExistAnyCardiologyData(selectedOnExamination?.systemicExamination) &&
          userInfo?.speciality[0] === '62eb9ede374ac6d73b089981' && (
            <SystemicExaminationView
              selectedOnExamination={selectedOnExamination}
              setSelectedOnExamination={setSelectedOnExamination}
              prescriptionItems={prescriptionItems}
              isHistoryPage={isHistoryPage}
            />
          )} */}

        {(isExistAnyGyneData(selectedOnExamination?.gyneExamination) ||
          isExistAnyBreastData(selectedOnExamination?.breastExamination) ||
          isExistAnyOthersData(selectedOnExamination?.others) ||
          isExistAnyEarNoseThrothsData(
            selectedOnExamination?.earNoseThroths,
          )) && (
          <GyneExaminationView
            selectedOnExamination={selectedOnExamination}
            setSelectedOnExamination={setSelectedOnExamination}
            prescriptionItems={prescriptionItems}
            isHistoryPage={isHistoryPage}
          />
        )}

        {isExistAnyDentalData(selectedOnExamination?.dentalExamination) && (
          <DentalView
            selectedOnExamination={selectedOnExamination}
            setSelectedOnExamination={setSelectedOnExamination}
            prescriptionItems={prescriptionItems}
            isHistoryPage={isHistoryPage}
          />
        )}
        {isExistAnyMentalStateExaminationData(
          selectedOnExamination?.mentalStateExamination,
        ) && (
          <MentalStateExaminationView
            prescriptionItems={prescriptionItems}
            selectedOnExamination={selectedOnExamination}
            setSelectedOnExamination={setSelectedOnExamination}
            isHistoryPage={isHistoryPage}
          />
        )}

        {isExistAnyEarNoseThrothsData(
          selectedOnExamination?.earNoseThroths,
        ) && (
          <EarNoseThrothExamination
            selectedOnExamination={selectedOnExamination}
            setSelectedOnExamination={setSelectedOnExamination}
            prescriptionItems={prescriptionItems}
            isHistoryPage={isHistoryPage}
          />
        )}
        {isExistAnyNervousSystemData(selectedOnExamination?.nervousSystem) && (
          <NervousSystem
            selectedOnExamination={selectedOnExamination}
            setSelectedOnExamination={setSelectedOnExamination}
            prescriptionItems={prescriptionItems}
            isHistoryPage={isHistoryPage}
          />
        )}
        {isExistAnyUrologyExaminationData(
          selectedOnExamination?.urologyExamination,
        ) && (
          <UrologyExaminationView
            selectedOnExamination={selectedOnExamination}
            setSelectedOnExamination={setSelectedOnExamination}
            prescriptionItems={prescriptionItems}
            isHistoryPage={isHistoryPage}
          />
        )}
      </div>
    </div>
  );
};

export default memo(OnExamination);
